import { axiosInstance } from "../config/axios";

const endpoint = "prize/";

export const Create = async (params) => {
	try {
		const res = await axiosInstance.post(endpoint, params);
		console.log("====================================");
		console.log(res);
		console.log("====================================");
		const { data } = res;
		data["success"] = true;
		return res.data;
	} catch (e) {
		const data = {
			success: false,
		};
		return data;
	}
};

export const Update = async (params, id) => {
	try {
		const res = await axiosInstance.put(`${endpoint}${id}/`, params);
		console.log("====================================");
		console.log(res);
		console.log("====================================");
		const { data } = res;
		data["success"] = true;
		return res.data;
	} catch (e) {
		console.log("====================================");
		console.log(e);
		console.log("====================================");
		const data = {
			success: false,
		};
		return data;
	}
};

export const getAllSeller = async () => {
	try {
		const res = await axiosInstance.get(endpoint);

		const { data } = res;
		data["success"] = true;
		return res.data;
	} catch (e) {
		const data = {
			success: false,
		};
		return data;
	}
};

export const getStylistUsers = async () => {
	try {
		const url = `stylist/`;
		const res = await axiosInstance.get(url);

		const { data } = res;
		data["success"] = true;
		return res.data;
	} catch (e) {
		const data = {
			success: false,
		};
		return data;
	}
};
